import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <main className="state-page">
      <p className="eyebrow">404</p>
      <h1>This page has wandered out back.</h1>
      <p>The address may have changed or no longer exists.</p>
      <Link className="button button--dark" to="/">
        Return to Backyard
      </Link>
    </main>
  );
}
